import TaskItem from '@tiptap/extension-task-item';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { TaskItemComponent } from './TaskItemComponent.js';

const TaskItemExtension = TaskItem.extend({
  addNodeView() {
    return ReactNodeViewRenderer(TaskItemComponent);
  }
});

export { TaskItemExtension };
//# sourceMappingURL=TaskItemExtension.js.map
